<table class="border-separate w-full" style="border-spacing: 0" role="grid">
  <thead>
    <tr>
      @for (day of _weekdays; track day) {
      <th class="text-center pt-0 pb-[6px] px-0" scope="col">
        <span class="border-0 h-[1px] -m-[1px] overflow-hidden p-0 absolute w-[1px] whitespace-nowrap outline-0 appearance-none left-0"
          >{{day.long}}</span
        >
        <span class="font-medium text-small text-text-200" aria-hidden="true">{{day.long | slice: 0:2}}</span>
      </th>
      }
    </tr>
  </thead>
  <tbody
    mat-calendar-body
    [label]="_monthLabel"
    [rows]="_weeks"
    [todayValue]="_todayDate!"
    [startValue]="_rangeStart!"
    [endValue]="_rangeEnd!"
    [comparisonStart]="_comparisonRangeStart"
    [comparisonEnd]="_comparisonRangeEnd"
    [previewStart]="_previewStart"
    [previewEnd]="_previewEnd"
    [isRange]="_isRange"
    [labelMinRequiredCells]="3"
    [activeCell]="_dateAdapter.getDate(activeDate) - 1"
    (selectedValueChange)="_dateSelected($event)"
    (activeDateChange)="_updateActiveDate($event)"
    (previewChange)="_previewChanged($event)"
    (keyup)="_handleCalendarBodyKeyup($event)"
    (keydown)="_handleCalendarBodyKeydown($event)"
  ></tbody>
</table>
